import { useEffect, useState } from "react";
import { useDebounce } from "../../../../../hooks/useDebounce";
import { producaov2 } from "../../../../../services/apis";

export default function useUsers({ search = '' }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const debouncedSearch = useDebounce(search, search ? 500 : 0);

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);

        const response = await producaov2.get('/alunos', {
          params: {
            limit: 20,
            search: debouncedSearch,
          }
        });

        setData(response.data);
      } catch(error) {
        setData([]);
      } finally {
        setLoading(false);
      }
    }

    getData();
  }, [debouncedSearch]);

  useEffect(() => {
    if(!loading) {
      setLoading(true);
    }
  }, [search]);

  return {
    data,
    loading
  }
}